import SuitabilityForm from './SuitabilityForm'

export default SuitabilityForm
